import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <AppSection />
        <ContactSection />
        <AboutSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <MediaSection />
        <CarouselSection />
        <CardsSection />
        <FaqSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}